import Stack from "@mui/material/Stack";
import DataContainer from "../../../Utilities/DataContainer";
import RenderTextField from "../../../Utilities/Forms/RenderTextField";
import DropDownViewModel from "../../../Utilities/ViewModels/DropDownViewModel";
import RenderSelectField from "../../../Utilities/Forms/RenderSelectField";

interface IProps {
    isReadOnly: boolean;
    landuse: string;
    subuse: string;
}

export default function Facilities({ isReadOnly, landuse, subuse }: IProps) {

    const sharedOptionLables: DropDownViewModel[] = [
        { id: 'U', data: 'U', label: 'Unknown' },
        { id: 'Y', data: 'Y', label: 'Yes' },
        { id: 'N', data: 'N', label: 'No' },
        { id: null, data: null, label: 'N/A' },
    ];

    return (
        <DataContainer title="Facilities">
            <Stack spacing={1}>
                {(landuse === "03" && subuse === "Q") && (
                    <>
                        <RenderTextField label="Accommodation Units" name="facilities.accomodationUnits" readOnly={isReadOnly} />

                        <RenderSelectField label="Gym Or Fitness Studios" name="facilities.gymOrFitnessStudios" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="How Many Gym Or Fitness Studios At Site" name="facilities.howManyGymOrFitnessStudiosAtSite" readOnly={isReadOnly} />

                        <RenderSelectField label="Shared Kitchens" name="facilities.sharedKitchens" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="How Many Shared Kitchens At Site" name="facilities.howManySharedKitchensAtSite" readOnly={isReadOnly} />

                        <RenderSelectField label="Communal Gardens And Outdoor Areas" name="facilities.communalGardensAndOutdoorAreas" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="How Many Communal Gardens And Outdoor Areas At Site" name="facilities.howManyCommunalGardnesAndOutdoorAreasAtSite" readOnly={isReadOnly} />

                        <RenderSelectField label="Cinema Or TV Rooms" name="facilities.cinemaOrTvRooms" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="How Many Cinema Or TV Rooms At Site" name="facilities.howManyCinemaOrTvRoomsAtSite" readOnly={isReadOnly} />

                        <RenderSelectField label="Communal Lounges" name="facilities.communalLounges" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="How Many Communal Lounges At Site" name="facilities.howManyCommunalLoungesAtSite" readOnly={isReadOnly} />

                        <RenderSelectField label="Communal Workstations" name="facilities.communalWorkstations" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="How Many Communal Workspaces At Site" name="facilities.howManyCommunalWorkspacesAtSite" readOnly={isReadOnly} />

                        <RenderSelectField label="Restaurants Cafes Or Bars" name="facilities.restaurantsCafesOrBars" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="How Many Restaurants Or Cafes Or Bars At Site" name="facilities.howManyRestaurantsOrCafesOrBarsAtSite" readOnly={isReadOnly} />

                        <RenderSelectField label="Library Or Games Room" name="facilities.libraryOrGamesRoom" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="How Many Library Or Games Rooms At Site" name="facilities.howManyLibraryOrGamesRoomsAtSite" readOnly={isReadOnly} />

                        <RenderTextField label="Specify Facilities" name="facilities.specifiyFacilities" readOnly={isReadOnly} />

                        <RenderSelectField label="Other Facilities" name="facilities.otherFacilities" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="How Many Other At Site" name="facilities.howManyOtherAtSite" readOnly={isReadOnly} />
                    </>
                )}
                {(landuse === "07" && subuse === "C") && (
                    <>{
                        <RenderSelectField label="Includes Gym" name="facilities.includesGym" readOnly={isReadOnly} options={sharedOptionLables} />}

                        <RenderSelectField label="Includes Swimming Pool" name="facilities.includesSwimmingPool" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="Area Of Main Swimming Pool" name="facilities.areaOfMainSwimmingPool" readOnly={isReadOnly} />

                        <RenderSelectField label="Includes Squash Courts" name="facilities.includesSquashCourts" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="Total Squash Courts" name="facilities.totalSquashCourts" readOnly={isReadOnly} />

                        <RenderSelectField label="Includes Other Courts" name="facilities.includesOtherCourts" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="Number Of Other Courts" name="facilities.numberOfOtherCourts" readOnly={isReadOnly} />

                        <RenderSelectField label="Includes Fitness Studio" name="facilities.includesFitnessStudio" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="Number Of Fitness Studios" name="facilities.numberOfFitnessStudios" readOnly={isReadOnly} />

                        <RenderSelectField label="Includes Outdoor Pitches" name="facilities.includesOutdoorPitches" readOnly={isReadOnly} options={sharedOptionLables} />
                        <RenderTextField label="Number Of Outdoor Pitches" name="facilities.numberOfOutdoorPitches" readOnly={isReadOnly} />
                    </>
                )}
            </Stack>
        </DataContainer>
    );
}
